import useTrialsByUserAndInstitutionId from "@/hooks/data/useTrialsByUserAndInstitutionId";
import { createContext } from "react"

export interface ITrialsContext extends ReturnType<typeof useTrialsByUserAndInstitutionId> {
}

export const TrialsContext = createContext<ITrialsContext>({
    data: undefined,
    loading: false,
    validating: false,
    error: undefined,
    mutate: async () => { return undefined },
    refresh: async () => { return undefined }
});

export default TrialsContext;